import { useMemo } from 'react';
import { useOpts } from '../../../../context';
var usePercentageSupported = function () {
    var opts = useOpts();
    var selectedEmployer = opts.selectedEmployer, loadedPlatform = opts.loadedPlatform;
    var percentageSupported = useMemo(function () {
        if (selectedEmployer)
            return selectedEmployer.percentageSupported;
        // DD forms search entrypoint - loadedPlatform is not defined
        if (!loadedPlatform)
            return true;
        return loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.percentageSupported;
    }, [loadedPlatform, selectedEmployer]);
    return percentageSupported;
};
export default usePercentageSupported;
